<template>
  <div style="width: 100%; min-height: 100vh; background: #ffffff">
    <div class="pageTop" style="position: fixed; top: 0; left: 0; right: 0; height: 46px; line-height: 46px; text-align: center; color: white; font-size: 18px; background: url(/img/counter/top-bg.webp) no-repeat #084ccb; z-index: 1000;">
      <img src="/static/image/nav_chevron_back.bb0f0ac706614ab578365b31d203927a.png" alt="" style="width: 16px; height: 16px; position: absolute; left: 15px; top: 50%; transform: translateY(-50%); cursor: pointer;" @click="$router.back()" />
      {{ $t('Welfare Center') }}
    </div>
    <div style="height: 46px"></div>
    <div style="width: 95%;min-width:250px; margin: 0 auto; background: #fff; border-radius: 10px; box-sizing: border-box; padding: 10px; min-height: 90vh">
      <div style="padding-bottom: 10px; display: flex; align-items: center; justify-content: space-between">
        <span style="font-size: 0.3rem"> {{ $t('Red Envelope Record') }} </span>

        <van-button style="width:auto;height: 0.68rem;min-width:80px;padding: 0 10px;" type="info" @click="$parent.goNav('/hongbao')">
          <span style="color: #fff; font-size: 0.3rem">{{ $t('Go to Claim') }}</span>
        </van-button>
      </div>
      
      <!-- 调整了布局，增加 flex-wrap 防止英文状态下溢出重叠 -->
      <div style="display: flex; box-sizing: border-box; padding: 0 4px; font-size: 0.28rem; justify-content: space-between; min-height: 1.1rem; align-items: center; flex-wrap: wrap; color: #333;">
        <div style="font-size: 0.28rem; margin-right: 10px; margin-bottom: 4px;">{{ $t('Remaining claims:') }}{{ userredpacket.sendnums }}</div>
        <div style="font-size: 0.28rem; margin-bottom: 4px;">{{ $t('Claimed times:') }}{{ userredpacket.acquirednum }}</div>
      </div>

      <!-- finished-text 改为了动态绑定 -->
      <van-list style="margin-top: 10px; padding-bottom: 120px" :finished-text="$t('No more data')" offset="300" v-model="loading" :finished="list.length == pageData.total" @load="getData" v-if="list.length > 0">
        <van-cell v-for="(item, index) in list" :key="index">
          <div style="color: #888 !important; font-size: 0.28rem;">
            <div style="display: flex; justify-content: space-between; flex-wrap: wrap; margin-bottom: 4px;">
              <span style="margin-right: 10px;">{{ $t('Recharge Amount:') }}{{ item.money }}</span> 
              <span>{{ $t('Bonus Amount:') }}{{ item.redpacketmoney }}</span>
            </div>
            <div style="margin-bottom: 4px;">{{ $t('Recharge Time:') }}{{ item.created_at }}</div>
            <div>{{ $t('Claim Time:') }}{{ item.usetime }}</div>
          </div>
        </van-cell>
      </van-list>
      <div v-else style="margin-top: 60px; text-align: center">
        <img src="/static/image/mescroll-empty.png" style="width: 35%" alt="" />
        <van-divider dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px ' }">{{ $t('Empty') }}</van-divider>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'welfare',
  data() {
    return {
      list: [],
      pageData: {},
      userredpacket: {},
      page: 1,
      loading: false,
    };
  },
  created() {
    let that = this;
    that.getuserredpacket();
    that.getData();
  },
  methods: {
    getData() {
      let that = this;
      let page = that.page;
      if (page > that.pageData.last_page) {
        that.loading = false;
        return;
      }
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun
        .post('/api/redpacket', info)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.pageData = res.data;

            if (that.page == 1) {
              that.list = res.data.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              res.data.data.forEach(el => {
                list.push(el);
              });
              that.list = list;
            }
            that.page = page + 1;
          }
          that.loading = false;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
          that.loading = false;
        });
    },
    getuserredpacket() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun.get('/api/userredpacket', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.userredpacket = res.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/welfare.vue